<template>

    <!-- 主容器 -->
    <div class="yx-div">
        <div style="position: absolute; margin-top: -10px; z-index: 99;">
            <span style="font-size: 13px; font-weight: bold; color: orange ">{{this.$router.currentRoute.name}}</span>
        </div>

        <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div  class="yx-flex-h-start2" style="margin-top: 5px;">
                    <div>
                        收款单名称：
                        <el-input placeholder="收款单名称" v-model="searchVal.subject" clearable size="mini" style="width: 200px; margin-right: 15px;" />
                    </div>
                    <div>
                        收款单信息：
                        <el-input placeholder="根据收款单关键信息查询" v-model="searchVal.remark" clearable size="mini" style="width: 200px; margin-right: 15px;" />
                    </div>
                    <!--
                    <div>
                        支付渠道：<el-select clearable v-model="searchVal.payWayCode" placeholder="支付渠道" size="mini" style="width: 120px;margin-right: 15px;">
                        <el-option class="f12"
                                   v-for="item in this._enums.PayWayEnum"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    </div>
                    -->
                    <!---->
                    <div>
                        交易类型：
                        <el-select clearable v-model="searchVal.status" placeholder="交易状态" size="mini" style="width: 100px;margin-right: 15px;">
                            <el-option class="f12"
                                       v-for="item in this._enums.TransStatusEnum"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>

                    <div>
                        交易日期：
                        <el-date-picker
                                v-model="searchVal.transDateScope"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                size="mini"
                                style="width:250px"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <!--
                    <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
                    -->
                    <el-button type="primary" icon="el-icon-search" @click="searchDo">查询</el-button>
                </div>
            </div>
        </div>



        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="transs"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="subject" label="收款单名称" align="center" width="200" show-overflow-tooltip />
                <el-table-column label="应收合计" align="right" width="100">
                    <template slot-scope="scope">
                        <span style="font-weight: bolder">{{scope.row.remark.order_amt.toFixed(2)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" align="center" width="80" >
                    <template slot-scope="scope">
                        <span style="color: green; font-weight: bolder" v-if="scope.row.status===1">已支付</span>
                        <span style="color: red;" v-else>未支付</span>
                    </template>
                </el-table-column>
                <el-table-column prop="paySuccTime" label="交易日期" align="center" width="100" :formatter="funDateFormatter" />
                <el-table-column prop="paySuccTime" label="交易时间" align="center" width="80" :formatter="funTimeFormatter" />
                <!-- 动态列 -->
                <el-table-column v-for="(item, index) in skInfo" :key="index" :label="item.key"
                                 :align="item.type===1?'right':'left'"
                                 :width="(item.info && item.info.fix_w)?item.info.fix_w:'100'">
                    <!--动态行-->
                    <template slot-scope="scope">
                        <div v-for="(item2, index2) in scope.row.remark.list" :key="index2">
                            <span v-if="item2.order===item.order">{{item2.value}}</span>
                        </div>
                    </template>
                </el-table-column>
                <!--
                <el-table-column prop="amount" label="手续费" align="right" width="80" :formatter="funFmtTemp" />
                <el-table-column prop="amount" label="实拨金额" align="right" width="100" :formatter="funFmtTransAmt" />
                -->
                <el-table-column prop="payWayCode" label="支付渠道" align="center" width="80" >
                    <template slot-scope="scope">
                        {{_enums.PayWayEnum.getNameById(scope.row.payWayCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="buyerId" label="交易账号" align="left" width="100" show-overflow-tooltip />
                <el-table-column prop="payOrderNo" label="订单号" align="center" width="160" />
                <el-table-column prop="terNo" label="收款单号" align="center" width="200" show-overflow-tooltip />
            </el-table>

        </div>

        <!-- 分页栏 -->
        <!--
        <div class="yx-flex-h-end">
            <el-pagination
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev,pager,next, jumper,->, total, slot"
                    :total="total">
            </el-pagination>
        </div>
        -->
        <div class="yx-flex-h-between">
            <div v-if="msgInfo" style="height:32px;line-height: 32px; font-family: 'Arial Black'; font-size: 15px; background-color:green; color: white; padding-left: 15px;padding-right: 15px; ">{{msgInfo}}</div>
            <div class="yx-flex-h-end">
                <el-pagination
                        :current-page.sync="page"
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev,pager,next, jumper,->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>


    </div>

</template>

<script>
    // name 组件名
    // data return 组件内的变量声明
    // created:html加载完成前 执行。执行顺序:父组件-子组件
    // mounted:html加载完成后 执行。执行顺序:子组件-父组件
    // methods:事件方法
    // watch:去监听一个值的变化，然后执行相对应的函数
    // computed:computed是属性调用，而methods是函数调用，computed带有缓存功能，而methods不是
    export default {
        name: "BillDown",
        //组件中的data和实例中的不一样，实例中的data是一个对象，而组件中的data则是一个方法并且返回一个对象
        data() {
            //所有的变量都是写在data 的return里面
            //使用return包裹后数据中变量只在当前组件中生效,不会影响其他组件。
            return {
                msgInfo: null,
                searchVal: {
                    subject : null,
                    remark: null,
                    payWayCode : null,
                    payModeCode : null,
                    transResult : null,
                    status : null,
                    transDateScope : null
                },
                loading: false, // 加载提示 v-loading 变量
                total: 0,       // 总计 变量
                page: 1,        // 页数 变量
                size: 10,       // 每页大小 变量

                acqChannels :[],   // 交易渠道 集合
                transs: [],   // 交易对象 数组变量
                skInfo: [],
                oneTransDetail: null,
                transJnlKey: {
                    sysDate:'',
                    sysTime:'',
                    sysSerial:''
                }
            }
        },
        mounted() {
            this.initTransJnl();
        },
        methods: {
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initTransJnl();
            },
            initTransJnl() {
                this.loading = true;
                let url = '/bill/sft-details/?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.subject) {
                    url += '&subject=' + this.searchVal.subject;
                }
                if (this.searchVal.remark) {
                    url += '&remark=' + this.searchVal.remark;
                }
                if (this.searchVal.status===0 || this.searchVal.status===1) {
                    url += '&status=' + this.searchVal.status;
                }
                if (this.searchVal.transDateScope) {
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                }

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.transs = resp.data;
                        this.total = resp.total;
                        this.msgInfo = resp.msgInfo;

                        if (this.transs && this.transs.length > 0 && this.transs[0].mchRemark) {
                            this.skInfo = JSON.parse(this.transs[0].mchRemark)
                            if (this.skInfo.list) {
                                this.skInfo = this.skInfo.list
                            }
                        }
                        // console.log("skInfo", JSON.stringify(this.skInfo))

                        for (let i=0; i<this.transs.length; i++) {
                            if (this.transs[i].remark) {
                                this.transs[i].remark = JSON.parse(this.transs[i].remark)
                                let sumAmt = 0
                                this.transs[i].remark.list.forEach(item => {
                                    if (item.type === 1 && item.value) {
                                        let amt = Math.floor(item.value * 100) / 100
                                        sumAmt  += Number(amt)
                                    }
                                })
                                this.transs[i].remark.order_amt = sumAmt

                            }
                        }
                        // console.log("this.transs", JSON.stringify(this.transs))

                        console.log("交易总笔数："+this.total);
                    }
                });
            },
            initTransAcqChannels() {
                this.getRequest('/bill/acqChannel').then(resp => {
                    if (resp) {
                        this.acqChannels = resp;
                        window.sessionStorage.setItem("acqChannels", JSON.stringify(resp));
                    }
                })
            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initTransJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initTransJnl();
            },
        }
    }
</script>

<style>

    .pageNormal {
        font-size: 13px;
        font-family: 微软雅黑;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }

    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .5s ease;
    }

    .slide-fade-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .style-input-width {
        max-width: 120px;
    }

    .xtable{position:absolute;bottom:100px;}
    .xfooter{position:absolute;bottom:0;width:100%;height:100px;background-color: #ffc0cb;}

</style>
